// 公共的侧边栏栏
import Layout from "@/pages/layout/layout";

// 不作为main组件子页面展示的页面单独写，如下
export const loginRouter = {
  path: "/login",
  name: "login",
  meta: {
    title: "Login - 登录",
    keepAlive: false,
  },
  component: () => import("@/pages/login/login"),
};
export const centerRouter = {
  path: "/center",
  name: "center",
  meta: {
    title: "center - 登录",
    keepAlive: false,
  },
  component: () => import("@/pages/login/center"),
};
export const agreementRouter = {
  path: "/agreement",
  name: "agreement",
  meta: {
    title: "agreement - 协议",
    keepAlive: false,
  },
  component: () => import("@/pages/agreement/agreement"),
};
// 错误页面
export const errorRouter = {
  path: "/error/:code",
  name: "error",
  meta: {
    title: "error",
  },
  component: () => import("@/pages/error/index"),
};

// 员工登录
export const staiffLoginRouter = {
  path: "/staiff_login",
  name: "staiff_login",
  meta: {
    title: "员工登录",
  },
  component: () => import("@/pages/basic/staffList/staffLogin"),
};

// 作为main组件子页面展示  但不在左侧菜单显示的路由卸载otherRoter里
export const otherRouter = {
  path: '',
  name: 'otherRouter',
  redirect: '/home/welcome',
  meta: {
    requireAuth: true,
    title: '首页',
  },
  component: Layout,
  children: [
    // {
    //   path: 'home',
    //   name: 'home',
    //   meta: {
    //     title: '首页',
    //     keepAlive: true,
    //   },
    //   component: () => import('@/pages/home/home'),
    // },
    {
      path: 'home/welcome',
      name: 'welcome',
      meta: {
        title: '首页',
        keepAlive: true,
      },
      component: () => import('@/pages/home/welcome'),
    },
    {
      path: 'personalinfo',
      name: 'personalinfo',
      meta: {
        title: '个人信息',
        keepAlive: false,
      },
      component: () =>
        import('@/pages/personalinfo/personalinfo'),
    },
    {
      path: 'assign_custom',
      name: 'assign_custom',
      meta: {
        title: '分配客户',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/assign_custom/assign_custom'),
    },
    {
      path: 'openCustomers',
      name: 'openCustomers',
      meta: {
        title: '公开客户',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/openCustomers/openCustomers'),
    },
    {
      path: 'buybackCustomers',
      name: 'buybackCustomers',
      meta: {
        title: '通知公告',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/buybackCustomers/buybackCustomers'),
    },
    {
      path: 'customerGrade',
      name: 'customerGrade',
      meta: {
        title: '客户等级设定',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/customerGrade/customerGrade'),
    },
    {
      path: 'customerIntention',
      name: 'customerIntention',
      meta: {
        title: '客户意向设定',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/customers/intention'),
    },
    {
      path: 'lineChinnel',
      name: 'lineChinnel',
      meta: {
        title: '入线渠道设定',
        keepAlive: true,
      },
      component: () => import('@/pages/lineChinnel/lineChinnel'),
    },
    {
      path: 'customers/list',
      name: 'myCustomers',
      meta: {
        title: '我的客户',
        keepAlive: true,
      },
      component: () => import('@/pages/customers/list'),
    },
    // {
    //   path: 'customers/customersTag',
    //   name: 'customersTag',
    //   meta: {
    //     title: '客户标签管理',
    //     keepAlive: true,
    //   },
    //   component: () => import('@/pages/customers/customersTag'),
    // },
    {
      path: 'customers/customersTag',
      name: 'customersTag',
      meta: {
        title: '客户标签管理',
        keepAlive: true,
      },
      component: () => import('@/pages/customers/customersTag'),
    },
    {
      path: 'customersList',
      name: 'customersList',
      meta: {
        title: '资源列表',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/customers/customersList'
        ),
    },
    {
      path: 'tiktokSource',
      name: 'tiktokSource',
      meta: {
        title: '抖店资源',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/customers/tiktokSource'
        ),
    },
    {
      path: 'customers/blacklist',
      name: 'blacklist',
      meta: {
        title: '客户黑名单',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/customers/blacklist'
        ),
    },
    {
      path: 'customers/resourceRecycle',
      name: 'resourceRecycle',
      meta: {
        title: '资源回收',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/customers/resourceRecycle'
        ),
    },
    {
      path: 'noOrderPay',
      name: 'noOrderPay',
      meta: {
        title: '无订单支付',
        keepAlive: true,
      },
      component: () => import('@/pages/noOrderPay/noOrderPay'),
    },
    {
      path: 'customerInformation',
      name: 'customerInformation',
      meta: {
        title: '客户资料',
        keepAlive: false,
      },
      component: () =>
        import(
          '@/pages/customers/information'
        ),
    },
    {
      path: 'quitDelegate',
      name: 'quitDelegate',
      meta: {
        title: '离职委派',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/quitDelegate/quitDelegate'),
    },
    {
      path: 'addressList',
      name: 'addressList',
      meta: {
        title: '收货地址',
        keepAlive: false,
      },
      component: () => import('@/pages/addressList/addressList'),
    },
    {
      path: 'add_order',
      name: 'add_order',
      meta: {
        title: '添加订单',
        keepAlive: false,
      },
      component: () => import('@/pages/orderBox/add_order'),
    },
    {
      path: 'modify_order',
      name: 'modify_order',
      meta: {
        title: '修改订单',
        keepAlive: false,
      },
      component: () => import('@/pages/orderBox/modify_order'),
    },
    {
      path: 'submit_order',
      name: 'submit_order',
      meta: {
        title: '提交订单',
        keepAlive: false,
      },
      component: () => import('@/pages/orderBox/add_order'),
    },
    {
      path: 'reviewOrder',
      name: 'reviewOrder',
      meta: {
        title: '审核订单2',
        keepAlive: true,
      },
      component: () => import('@/pages/reviewOrder/reviewOrder'),
    },
    {
      path: 'afterSale/afterOrderList',
      name: 'afterSaleOrdeList',
      meta: {
        title: '售后订单',
        keepAlive: true,
      },
      component: () => import('@/pages/orderBox/afterSale/afterOrderList'),
    },
    {
      path: 'afterSale/recordList',
      name: 'afterSaleRecordList',
      meta: {
        title: '售后记录'
      },
      component: () => import('@/pages/orderBox/afterSale/recordList'),
    },
    {
      path: 'logisticsOrderList',
      name: 'logisticsOrderList',
      meta: {
        title: '物流订单',
        keepAlive: true,
      },
      component: () => import('@/pages/orderBox/logisticsOrderList'),
    },
    {
      path: 'allOrder',
      name: 'allOrder',
      meta: {
        title: '全部订单',
        keepAlive: true,
      },
      component: () => import('@/pages/orderBox/allOrder'),
    },
    {
      path: 'saleOrder',
      name: 'saleOrder',
      meta: {
        title: '销售订单',
        keepAlive: true,
      },
      component: () => import('@/pages/orderBox/saleOrder/saleOrder'),
    },
    {
      path: 'splitOrder',
      name: 'splitOrder',
      meta: {
        title: '订单拆单',
        keepAlive: false,
      },
      component: () => import('@/pages/orderBox/splitOrder'),
    },
    {
      path: 'motherSplitOrder',
      name: 'motherSplitOrder',
      meta: {
        title: '订单拆单',
        keepAlive: false,
      },
      component: () => import('@/pages/orderBox/motherSplitOrder'),
    },
    {
      path: 'operatorsOrderList',
      name: 'operatorsOrderList',
      meta: {
        title: '运营订单',
        keepAlive: true,
      },
      component: () => import('@/pages/orderBox/operatorsOrderList'),
    },
    {
      path: 'examination/orderList',
      name: 'examinationOrderList',
      meta: {
        title: '审核订单'
      },
      component: () => import('@/pages/examination/orderList'),
    },
    {
      path: '/examination/commissionList',
      name: 'examinationCommissionList',
      meta: {
        title: '提成申诉审核'
      },
      component: () => import('@/pages/examination/commissionList'),
    },
    {
      path: 'examination/process',
      name: 'examinationProcess',
      meta: {
        title: '审批流设置',
        keepAlive: true,
      },
      component: () => import('@/pages/examination/process'),
    },
    {
      path: 'examination/processDetails',
      name: 'examinationProcessDetails',
      meta: {
        title: '审批流设置',
        keepAlive: false,
      },
      component: () => import('@/pages/examination/processDetails'),
    },
    {
      path: 'examination/label',
      name: 'examinationLabel',
      meta: {
        title: '标签审核',
        keepAlive: true,
      },
      component: () => import('@/pages/examination/label'),
    },
    {
      path: 'addGift',
      name: 'addGift',
      meta: {
        title: '添加赠品',
        keepAlive: true,
      },
      component: () => import('@/pages/addGift/addGift'),
    },
    {
      path: 'goodsList',
      name: 'goodsList',
      meta: {
        title: '商品列表',
        keepAlive: true,
      },
      component: () => import('@/pages/goods/goodsList'),
    },
    {
      path: 'shopExamine',
      name: 'shopExamine',
      meta: {
        title: '商品审核',
        keepAlive: true,
      },
      component: () => import('@/pages/goods/shopExamine'),
    },
    {
      path: 'transportationModel',
      name: 'transportationModel',
      meta: {
        title: '运费模板',
        keepAlive: true,
      },
      component: () => import('@/pages/goods/transportationModel'),
    },
    {
      path: 'transportationModelEdit',
      name: 'transportationModelEdit',
      meta: {
        title: '新增模板',
      },
      component: () => import('@/pages/goods/transportationModelEdit'),
    },
    {
      path: 'shopExamineDetail',
      name: 'shopExamineDetail',
      meta: {
        title: '审核详情',
      },
      component: () => import('@/pages/goods/shopExamineDetail'),
    },
    {
      path: 'goodsAdd',
      name: 'goodsAdd',
      meta: {
        title: '商品编辑',
      },
      component: () =>
        import('@/pages/goods/goodsAdd'),
    },
    {
      path: 'goodsEdit',
      name: 'goodsEdit',
      meta: {
        title: '商品编辑',
      },
      component: () =>
        import('@/pages/goods/goodsEdit'),
    },
    {
      path: 'goodsCategoryEdit',
      name: 'goodsCategoryEdit',
      meta: {
        title: '商品编辑',
      },
      component: () =>
        import('@/pages/goods/goodsCategoryEdit'),
    },
    {
      path: 'marketAttribute',
      name: 'marketAttribute',
      meta: {
        title: '销售属性',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/goods/marketAttribute'),
    },
    {
      path: 'goodsProperty',
      name: 'goodsProperty',
      meta: {
        title: '商品属性库',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/goods/goodsProperty'),
    },
    {
      path: 'categoryManage',
      name: 'categoryManage',
      meta: {
        title: '类目管理',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/goods/categoryManage/categoryManage'),
    },
    {
      path: 'brandList',
      name: 'brandList',
      meta: {
        title: '品牌管理',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/goods/brandList/brandList'),
    },
    {
      path: 'addGoodsWareHouse',
      name: 'addGoodsWareHouse',
      meta: {
        title: '商品仓库',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/goods/addGoodsWareHouse/addGoodsWareHouse'
        ),
    },
    {
      path: 'location',
      name: 'location',
      meta: {
        title: '商品库位',
        keepAlive: false,
      },
      component: () => import('@/pages/goods/location/location'),
    },
    {
      path: 'addGoodsType',
      name: 'addGoodsType',
      meta: {
        title: '添加商品分类',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/goods/addGoodsType/addGoodsType'),
    },
    {
      path: 'addGoods',
      name: 'addGoods',
      meta: {
        title: '添加商品',
        keepAlive: true,
      },
      component: () => import('@/pages/goods/addGoods/addGoods'),
    },
    {
      path: 'subcategory',
      name: 'subcategory',
      meta: {
        title: '添加子分类',
        keepAlive: false,
      },
      component: () =>
        import('@/pages/goods/subcategory/subcategory'),
    },
    {
      path: 'giftList',
      name: 'giftList',
      meta: {
        title: '赠品列表',
        keepAlive: true,
      },
      component: () => import('@/pages/goods/giftList/giftList'),
    },
    {
      path: 'addGiftGoods',
      name: 'addGiftGoods',
      meta: {
        title: '添加赠品',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/goods/addGiftGoods/addGiftGoods'),
    },
    {
      path: 'brand',
      name: 'brand',
      meta: {
        title: '品牌列表',
        keepAlive: true,
      },
      component: () => import('@/pages/goods/brand/brand'),
    },
    {
      path: 'norms',
      name: 'norms',
      meta: {
        title: '商品规格',
        keepAlive: true,
      },
      component: () => import('@/pages/goods/norms/norms'),
    },
    {
      path: 'unabsorbed',
      name: 'unabsorbed',
      meta: {
        title: '未分配客户',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/siteinfo/unabsorbed/unabsorbed'),
    },
    {
      path: 'orderView',
      name: 'orderView',
      meta: {
        title: '订单查看',
        keepAlive: false,
      },
      component: () =>
        import('@/pages/siteinfo/orderView/orderView'),
    },
    {
      path: 'customerImport',
      name: 'customerImport',
      meta: {
        title: '客服客户导入',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/siteinfo/customerImport/customerImport'
        ),
    },
    {
      path: 'JCResourcePool',
      name: 'JCResourcePool',
      meta: {
        title: '健驰资源池',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/siteinfo/JCResourcePool/JCResourcePool'
        ),
    },
    {
      path: 'jcGuide',
      name: 'jcGuide',
      meta: {
        title: '健驰客户导入',
        keepAlive: true,
      },
      component: () => import('@/pages/siteinfo/jcGuide/jcGuide'),
    },
    {
      path: '/JCResourcePool',
      name: '/JCResourcePool',
      meta: {
        title: '健驰资源池',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/siteinfo/jcGuide/jCResourcePool'),
    },
    {
      path: 'jcGuideDetail',
      name: 'jcGuideDetail',
      meta: {
        title: '查看订单',
        keepAlive: false,
      },
      component: () => import('@/pages/siteinfo/jcGuide/detail'),
    },
    {
      path: 'AssignedCustomers',
      name: 'AssignedCustomers',
      meta: {
        title: '已分配客户',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/siteinfo/AssignedCustomers/AssignedCustomers'
        ),
    },
    {
      path: 'deliverGoods',
      name: 'deliverGoods',
      meta: {
        title: '站外发货',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/siteinfo/deliverGoods/deliverGoods'),
    },
    {
      path: 'ordersList',
      name: 'ordersList',
      meta: {
        title: '客服订单',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/orderBox/ordersList'),
    },
    {
      path: 'tiktokOrder',
      name: 'tiktokOrder',
      meta: {
        title: '抖店订单',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/orderBox/tiktokOrder'),
    },
    {
      path: 'orderDetail',
      name: 'orderDetail',
      meta: {
        title: '订单详情',
        keepAlive: false,
      },
      component: () =>
        import('@/pages/orderBox/orderDetail/orderDetail'),
    },
    {
      path: 'orderDetails',
      name: 'orderDetails',
      meta: {
        title: '订单详情',
        keepAlive: false,
      },
      component: () =>
        import('@/pages/orderBox/orderDetails'),
    },
    {
      path: 'afterSaleDetails',
      name: 'afterSaleDetails',
      meta: {
        title: '售后详情',
        keepAlive: false,
      },
      component: () =>
        import('@/pages/orderBox/afterSale/afterSaleDetails'),
    },
    {
      path: 'transactionrecord',
      name: 'transactionrecord',
      meta: {
        title: '交易记录',
        keepAlive: false,
      },
      component: () =>
        import(
          '@/pages/orderBox/orderDetail/transactionrecord'
        ),
    },
    {
      path: 'fix_order',
      name: 'fix_order',
      meta: {
        title: '改单记录',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/orderBox/fix_order/fix_order'),
    },
    {
      path: 'fix_orderDetail',
      name: 'fix_orderDetail',
      meta: {
        title: '订单详情',
        keepAlive: false,
      },
      component: () =>
        import(
          '@/pages/orderBox/fix_orderDetail/fix_orderDetail'
        ),
    },
    {
      path: 'fixOrder',
      name: 'fixOrder',
      meta: {
        title: '修改订单',
        keepAlive: false,
      },
      component: () =>
        import('@/pages/orderBox/fixOrder/fixOrder'),
    },
    {
      path: 'wyUpdate',
      name: 'wyUpdate',
      meta: {
        title: '文员修改订单',
        keepAlive: false,
      },
      component: () =>
        import('@/pages/orderBox/fixOrder/wyUpdate'),
    },
    {
      path: 'unusualOrder',
      name: 'unusualOrder',
      meta: {
        title: '异常订单',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/orderBox/unusualOrder/unusualOrder'),
    },
    {
      path: 'clientReject',
      name: 'clientReject',
      meta: {
        title: '填写拒收详情',
        keepAlive: false,
      },
      component: () =>
        import('@/pages/orderBox/clientReject/clientReject'),
    },
    {
      path: 'applyReturnGoods',
      name: 'applyReturnGoods',
      meta: {
        title: '填写退货详情',
        keepAlive: false,
      },
      component: () =>
        import(
          '@/pages/orderBox/applyReturnGoods/applyReturnGoods'
        ),
    },
    {
      path: 'returned',
      name: 'returned',
      meta: {
        title: '异常订单',
        keepAlive: false,
      },
      component: () =>
        import('@/pages/orderBox/returned/returned'),
    },
    {
      path: 'confirmReceipt',
      name: 'confirmReceipt',
      meta: {
        title: '确定收货',
        keepAlive: false,
      },
      component: () =>
        import(
          '@/pages/orderBox/confirmReceipt/confirmReceipt'
        ),
    },
    {
      path: 'staffList',
      name: 'staffList',
      meta: {
        title: '员工列表',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/basic/staffList/staffList'),
    },
    {
      path: 'staiff_info',
      name: 'staiff_info',
      meta: {
        title: '员工信息',
        keepAlive: false,
      },
      component: () =>
        import('@/pages/basic/staiff_info/staiff_info'),
    },
    {
      path: 'jurisdiction',
      name: 'jurisdiction',
      meta: {
        title: '权限管理',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/basic/jurisdiction/jurisdiction'),
    }, {
      path: 'platform',
      name: 'platform',
      meta: {
        title: '平台管理',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/basic/configure/platform'),
    },
    {
      path: 'shop',
      name: 'shop',
      meta: {
        title: '店铺管理',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/basic/configure/shop'),
    },
    {
      path: 'company',
      name: 'company',
      meta: {
        title: '公司管理',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/basic/configure/company'),
    },
    {
      path: 'department',
      name: 'department',
      meta: {
        title: '部门管理',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/basic/configure/department'),
    },
    {
      path: 'role',
      name: 'role',
      meta: {
        title: '角色权限',
        keepAlive: true,
      },
      component: () => import('@/pages/basic/role/role'),
    },
    {
      path: 'position',
      name: 'position',
      meta: {
        title: '职位权限管理',
        requireAuth: true,
        keepAlive: true,
      },
      component: () => import('@/pages/basic/position/position'),
    },
    {
      path: 'shopSetting',
      name: 'shopSetting',
      meta: {
        title: '店铺权限设置',
        requireAuth: true,
        keepAlive: true,
      },
      component: () => import('@/pages/basic/shopSetting/shopSetting'),
    },
    {
      path: 'sysText',
      name: 'sysText',
      meta: {
        title: '系统文件',
        requireAuth: true,
        keepAlive: true,
      },
      component: () => import('@/pages/basic/sysText/sysText'),
    },
    {
      path: 'editSysText',
      name: 'editSysText',
      meta: {
        title: '添加/编辑系统文件',
      },
      component: () => import('@/pages/basic/sysText/editSysText'),
    },
    {
      path: 'menu',
      name: 'menu',
      meta: {
        title: '菜单管理',
        keepAlive: true,
      },
      component: () => import('@/pages/basic/menu/menu'),
    },
    {
      path: 'menuBtn',
      name: 'menuBtn',
      meta: {
        title: '菜单按钮',
        keepAlive: true,
      },
      component: () => import('@/pages/basic/menuBtn/menuBtn'),
    },
    {
      path: 'configuration',
      name: 'configuration',
      meta: {
        title: '审批配置',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/basic/configuration/configuration'),
    },
    {
      path: 'limitsSelects',
      name: 'limitsSelects',
      meta: {
        title: '菜单权限',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/basic/limitsSelects/limitsSelects'),
    },
    {
      path: 'broadcast',
      name: 'broadcast',
      meta: {
        title: '轮播配置',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/basic/broadcast/broadcast'),
    },
    {
      path: 'newDaily',
      name: 'newDaily',
      meta: {
        title: '更新日志',
        keepAlive: true,
      },
      component: () => import('@/pages/help/newDaily'),
    },
    {
      path: 'documentation',
      name: 'documentation',
      meta: {
        title: '说明文档',
        keepAlive: true,
      },
      component: () => import('@/pages/help/documentation'),
    },
    {
      path: 'logisticsDetail',
      name: 'logisticsDetail',
      meta: {
        title: 'tt',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/warehouse/logisticsDetail/logisticsDetail'
        ),
    },
    {
      path: 'dailyRecord',
      name: 'dailyRecord',
      meta: {
        title: '操作日志',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/dailyRecordBox/dailyRecord/dailyRecord'
        ),
    },
    {
      path: 'dailyLogin',
      name: 'dailyLogin',
      meta: {
        title: '登录日志',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/dailyRecordBox/dailyLogin/dailyLogin'),
    },
    {
      path: 'customerListOrder',
      name: 'customerListOrder',
      meta: {
        title: '客户订单',
        keepAlive: false,
      },
      component: () =>
        import('@/pages/customerListOrder/customerListOrder'),
    },
    {
      path: 'fixpassword',
      name: 'fixpassword',
      meta: {
        title: '修改密码',
        keepAlive: false,
      },
      component: () => import('@/pages/fixpassword/fixpassword'),
    },
    {
      path: 'logisticsSystem/deliveryType',
      name: 'deliveryType',
      meta: {
        title: '出库类型',
        keepAlive: false,
      },
      component: () =>
        import(
          '@/pages/logisticsSystem/InternalDelivery/deliveryType/deliveryType'
        ),
    },
    {
      path: 'logisticsSystem/addInternal',
      name: 'addInternal',
      meta: {
        title: '添加内部出库',
        keepAlive: false,
      },
      component: () =>
        import(
          '@/pages/logisticsSystem/InternalDelivery/addInternal/addInternal'
        ),
    },
    {
      path: 'logisticsSystem/addInternalBack',
      name: 'addInternalCopy',
      meta: {
        title: '添加内部出库',
        keepAlive: false,
      },
      component: () =>
        import(
          '@/pages/logisticsSystem/InternalDelivery/addInternal/addInternalBack'
        ),
    },
    {
      path: 'logisticsSystem/examine',
      name: 'examine',
      meta: {
        title: '订单审核',
        keepAlive: false,
      },
      component: () =>
        import(
          '@/pages/logisticsSystem/InternalDelivery/examine/examine'
        ),
    },
    {
      path: 'platformIogisticsOrderList',
      name: 'platformIogisticsOrderList',
      meta: {
        title: '平台物流订单',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/platformOrderManagement/logisticsOrderList'
        ),
    },
    {
      path: 'platformIogisticsOrderDetail',
      name: 'platformIogisticsOrderDetail',
      meta: {
        title: '订单详情',
        keepAlive: false,
      },
      component: () =>
        import(
          '@/pages/platformOrderManagement/orderDetail'
        ),
    },
    {
      path: 'platformAfterOrderList',
      name: 'platformAfterOrderList',
      meta: {
        title: '平台售后订单',
        keepAlive: false,
      },
      component: () =>
        import(
          '@/pages/platformOrderManagement/afterOrderList'
        ),
    },
    {
      path: 'platformAfterOrderDetail',
      name: 'platformAfterOrderDetail',
      meta: {
        title: '售后订单详情',
        keepAlive: false,
      },
      component: () =>
        import(
          '@/pages/platformOrderManagement/afterSaleDetails'
        ),
    },
    {
      path: 'logisticsSystem/InternalList',
      name: 'InternalList',
      meta: {
        title: '内部出库',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/logisticsSystem/InternalDelivery/InternalList/InternalList'
        ),
    },
    {
      path: 'InternalOrderDetail',
      name: 'InternalOrderDetail',
      meta: {
        title: '内部出库详情',
        keepAlive: false,
      },
      component: () =>
        import(
          '@/pages/logisticsSystem/InternalDelivery/InternalOrderDetail/InternalOrderDetail'
        ),
    },
    {
      path: 'addReturn',
      name: 'addReturn',
      meta: {
        title: '内部出库退货',
        keepAlive: false,
      },
      component: () =>
        import(
          '@/pages/logisticsSystem/InternalDelivery/addReturn/addReturn'
        ),
    },
    {
      path: 'logisticsSystem/toAuditDetails',
      name: 'toAuditDetails',
      meta: {
        title: '待审核退货详情',
        keepAlive: false,
      },
      component: () =>
        import(
          '@/pages/logisticsSystem/stockManagement/toAuditAndDataQueryDetails/toAuditDetails'
        ),
    },
    {
      path: 'logisticsSystem/returnInventoryList',
      name: 'returnInventoryList',
      meta: {
        title: '异常入库列表',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/logisticsSystem/stockManagement/toAuditReturn/returnInventoryList'
        ),
    },
    {
      path: 'logisticsSystem/addStorageList',
      name: 'addStorageList',
      meta: {
        title: '采购入库列表',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/logisticsSystem/stockManagement/toAuditReturn/addStorageList'
        ),
    },
    {
      path: 'logisticsSystem/addStorage',
      name: 'addStorage',
      meta: {
        title: '采购入库',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/logisticsSystem/stockManagement/toAuditReturn/addStorage'
        ),
    },
    {
      path: 'logisticsSystem/productData',
      name: 'productData',
      meta: {
        title: '产品数据',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/logisticsSystem/stockManagement/dataQuery/productData'
        ),
    },
    {
      path: 'logisticsSystem/productDataDetails',
      name: 'productDataDetails',
      meta: {
        title: '数据详情',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/logisticsSystem/stockManagement/toAuditAndDataQueryDetails/productDataDetails'
        ),
    },
    {
      path: 'logisticsSystem/warehouseData',
      name: 'warehouseData',
      meta: {
        title: '仓库数据',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/logisticsSystem/stockManagement/dataQuery/warehouseData'
        ),
    },
    {
      path: 'logisticsSystem/orderData',
      name: 'orderData',
      meta: {
        title: '订单数据',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/logisticsSystem/stockManagement/dataQuery/orderData'
        ),
    },
    {
      path: 'attachment',
      name: 'attachment',
      meta: {
        title: '查看附件',
        keepAlive: false,
      },
      component: () => import('@/pages/attachment/attachment'),
    },
    {
      path: 'recordSetting',
      name: 'recordSetting',
      meta: {
        title: '跟进记录设定',
        keepAlive: false,
      },
      component: () =>
        import('@/pages/customerBox/recordSetting'),
    },
    // {
    //   path: "logisticsSystem/tobeDelivered",
    //   name: "tobeDelivered",
    //   meta: {
    //     title: "待发货订单",
    //     keepAlive: true,
    //   },
    //   component: () =>
    //     import(
    //       "@/pages/logisticsSystem/InternalDelivery/tobeDelivered/tobeDelivered"
    //     ),
    // },
    // {
    //   path: "logisticsSystem/signedIn",
    //   name: "signedIn",
    //   meta: {
    //     title: "已签收订单",
    //     keepAlive: true,
    //   },
    //   component: () =>
    //     import("@/pages/logisticsSystem/InternalDelivery/signedIn/signedIn"),
    // },
    {
      path: 'logisticsIndex',
      name: 'logisticsIndex',
      meta: {
        title: '物流首页',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/logisticsSystem/stockManagement/logisticsIndex'
        ),
    },
    {
      path: 'warehouseStock',
      name: 'warehouseStock',
      meta: {
        title: '仓库库存',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/logisticsSystem/warehouseManagement/warehouseStock/warehouseStock'
        ),
    },
    {
      path: 'checkList',
      name: 'checkList',
      meta: {
        title: '盘点列表',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/logisticsSystem/warehouseManagement/warehouseStock/checkList'
        ),
    },
    {
      path: 'checkFillIn',
      name: 'checkFillIn',
      meta: {
        title: '盘点填写',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/logisticsSystem/warehouseManagement/warehouseStock/checkFillIn'
        ),
    },
    {
      path: 'warehousesList',
      name: 'warehousesList',
      meta: {
        title: '仓库调拨列表',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/logisticsSystem/warehouseManagement/wareUpdateList/warehousesList'
        ),
    },
    {
      path: 'wareApplyForList',
      name: 'wareApplyForList',
      meta: {
        title: '调拨申请列表',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/logisticsSystem/warehouseManagement/wareUpdateList/wareApplyForList'
        ),
    },
    {
      path: 'goodsRecord',
      name: 'goodsRecord',
      meta: {
        title: '商品记录详情',
        keepAlive: false,
      },
      component: () =>
        import(
          '@/pages/logisticsSystem/warehouseManagement/warehouseStock/goodsRecord'
        ),
    },
    {
      path: 'addAdjustment',
      name: 'addAdjustment',
      meta: {
        title: '添加库存调整',
        keepAlive: false,
      },
      component: () =>
        import(
          '@/pages/logisticsSystem/warehouseManagement/warehouseStock/addAdjustment'
        ),
    },
    {
      path: 'wareUpdateList',
      name: 'wareUpdateList',
      meta: {
        title: '库存调整',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/logisticsSystem/warehouseManagement/wareUpdateList/wareUpdateList'
        ),
    },
    {
      path: 'wareUpdate',
      name: 'wareUpdate',
      meta: {
        title: '库存调拨修改',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/logisticsSystem/warehouseManagement/wareUpdateList/wareUpdate'
        ),
    },
    {
      path: 'LiveOrder',
      name: 'LiveOrder',
      meta: {
        title: '外部订单',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/orderBox/LiveOrder/LiveOrder'),
    },
    {
      path: 'purchasingList',
      name: 'purchasingList',
      meta: {
        title: '采购单列表',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/purchasingManagement/purchasingList.vue'
        ),
    },
    {
      path: 'purchasingAddList',
      name: 'purchasingAddList',
      meta: {
        title: '采购入库列表',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/purchasingManagement/purchasingAddList.vue'
        ),
    },
    {
      path: 'purchasingReopen',
      name: 'purchasingReopen',
      meta: {
        title: '重开采购单',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/purchasingManagement/purchasingReopen.vue'
        ),
    },
    {
      path: 'purchasingReturnList',
      name: 'purchasingReturnList',
      meta: {
        title: '采购退货列表',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/purchasingManagement/purchasingReturnList.vue'
        ),
    },
    {
      path: 'add_supplier',
      name: 'add_supplier',
      meta: {
        title: '新增供应商',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/supplierManagement/add_supplier/add_supplier'
        ),
    },
    {
      path: 'vendorStarted',
      name: 'vendorStarted',
      meta: {
        title: '供应商列表',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/supplierManagement/vendorStarted/vendorStarted'
        ),
    },
    {
      path: 'purchasingUpdate',
      name: 'purchasingUpdate',
      meta: {
        title: '重开采购入库单',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/purchasingManagement/purchasingUpdate.vue'
        ),
    },
    {
      path: 'purchasingAdd',
      name: 'purchasingAdd',
      meta: {
        title: '新增采购单',
        keepAlive: false,
      },
      component: () =>
        import(
          '@/pages/purchasingManagement/purchasingAdd.vue'
        ),
    },
    {
      path: 'purchasingAddFix',
      name: 'purchasingAddFix',
      meta: {
        title: '修改采购单',
        keepAlive: false,
      },
      component: () =>
        import(
          '@/pages/purchasingManagement/purchasingAddFix.vue'
        ),
    },
    {
      path: 'rkFix',
      name: 'rkFix',
      meta: {
        title: '修改入库单',
        keepAlive: false,
      },
      component: () =>
        import('@/pages/purchasingManagement/rkFix.vue'),
    },
    {
      path: 'purchasingExchangeFix',
      name: 'purchasingExchangeFix',
      meta: {
        title: '修改换货单',
        keepAlive: false,
      },
      component: () =>
        import(
          '@/pages/purchasingManagement/exchange/purchasingExchangeFix.vue'
        ),
    },
    {
      path: 'newStock',
      name: 'newStock',
      meta: {
        title: '添加采购入库单',
        keepAlive: false,
      },
      component: () =>
        import('@/pages/purchasingManagement/newStock.vue'),
    },
    {
      path: 'addExchangeOrder',
      name: 'addExchangeOrder',
      meta: {
        title: '添加采购换货单',
        keepAlive: false,
      },
      component: () =>
        import(
          '@/pages/purchasingManagement/exchange/addExchangeOrder.vue'
        ),
    },
    {
      path: 'returnFix',
      name: 'returnFix',
      meta: {
        title: '修改退货单',
        keepAlive: false,
      },
      component: () =>
        import(
          '@/pages/purchasingManagement/returned/returnFix.vue'
        ),
    },
    {
      path: 'purchaseInformation',
      name: 'purchaseInformation',
      meta: {
        title: '采购入库信息',
        keepAlive: false,
      },
      component: () =>
        import(
          '@/pages/purchasingManagement/purchaseInformation.vue'
        ),
    },
    {
      path: 'exchangeInformation',
      name: 'exchangeInformation',
      meta: {
        title: '采购入库信息',
        keepAlive: false,
      },
      component: () =>
        import(
          '@/pages/purchasingManagement/exchange/exchangeInformation.vue'
        ),
    },
    {
      path: 'returnRequest',
      name: 'returnRequest',
      meta: {
        title: '采购入库退货',
        keepAlive: false,
      },
      component: () =>
        import(
          '@/pages/purchasingManagement/returned/returnRequest.vue'
        ),
    },
    {
      path: 'returnInformation',
      name: 'returnInformation',
      meta: {
        title: '确认采购入库退货信息',
        keepAlive: false,
      },
      component: () =>
        import(
          '@/pages/purchasingManagement/returned/returnInformation.vue'
        ),
    },
    {
      path: 'purchasingReturnList',
      name: 'purchasingReturnList',
      meta: {
        title: '采购退货列表',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/purchasingManagement/purchasingReturnList.vue'
        ),
    },
    {
      path: 'purchasingExchangeList',
      name: 'purchasingExchangeList',
      meta: {
        title: '采购换货列表',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/purchasingManagement/exchange/purchasingExchangeList.vue'
        ),
    },
    //矩阵管理
    {
      path: 'platList',
      name: 'platList',
      meta: {
        title: '平台列表',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/platformManage/platList/index.vue'),
    },
    {
      path: 'platListDetail',
      name: 'platListDetail',
      meta: {
        title: '平台详情',
      },
      component: () =>
        import('@/pages/platformManage/platList/detail.vue'),
    },
    {
      path: 'lookPlatform',
      name: 'lookPlatform',
      meta: {
        title: '平台详情',
      },
      component: () =>
        import('@/pages/platformManage/platList/lookPlatform.vue'),
    },
    {
      path: 'applet',
      name: 'applet',
      meta: {
        title: '关联小程序',
      },
      component: () =>
        import('@/pages/platformManage/platList/applet.vue'),
    },
    {
      path: 'settingPlatform',
      name: 'settingPlatform',
      meta: {
        title: '平台设置',
      },
      component: () =>
        import('@/pages/platformManage/platList/settingPlatform.vue'),
    },
    {
      path: 'settingVip',
      name: 'settingVip',
      meta: {
        title: '会员设置',
      },
      component: () =>
        import('@/pages/platformManage/platList/settingVip.vue'),
    },
    {
      path: 'newVip',
      name: 'newVip',
      meta: {
        title: '新增会员',
      },
      component: () =>
        import('@/pages/platformManage/platList/newVip.vue'),
    },
    {
      path: 'vipEquity',
      name: 'vipEquity',
      meta: {
        title: '会员权益',
      },
      component: () =>
        import('@/pages/platformManage/platList/vipEquity.vue'),
    },
    {
      path: 'platformCouponManage',
      name: 'platformCouponManage',
      meta: {
        title: '平台优惠券管理',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/platformManage/platformCouponManage/platformCouponManage.vue'),
    },
    {
      path: 'newCoupon',
      name: 'newCoupon',
      meta: {
        title: '新增优惠券',
      },
      component: () =>
        import('@/pages/platformManage/platformCouponManage/newCoupon.vue'),
    },
    {
      path: 'receiveDetail',
      name: 'receiveDetail',
      meta: {
        title: '领取详情',
      },
      component: () =>
        import('@/pages/platformManage/platformCouponManage/receiveDetail.vue'),
    },
    {
      path: 'useDetail',
      name: 'useDetail',
      meta: {
        title: '使用详情',
      },
      component: () =>
        import('@/pages/platformManage/platformCouponManage/useDetail.vue'),
    },
    {
      path: 'user',
      name: 'user',
      meta: {
        title: '用户管理',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/platformManage/user/index.vue'),
    },
    {
      path: 'userDetail',
      name: 'userDetail',
      meta: {
        title: '用户详情',
      },
      component: () =>
        import('@/pages/platformManage/user/detail.vue'),
    },
    {
      path: 'settlementFund',
      name: 'settlementFund',
      meta: {
        title: '结算金管理',
        keepAlive: true
      },
      component: () =>
        import('@/pages/platformManage/settlementFund/settlementFund.vue'),
    },
    {
      path: 'platformSettlementFund',
      name: 'platformSettlementFund',
      meta: {
        title: '平台结算金',
        keepAlive: false
      },
      component: () =>
        import('@/pages/platformManage/settlementFund/platformSettlementFund.vue'),
    },
    {
      path: 'platformSettlementFundDetail',
      name: 'platformSettlementFundDetail',
      meta: {
        title: '结算商品详情',
        keepAlive: false
      },
      component: () =>
        import('@/pages/platformManage/settlementFund/platformSettlementFundDetail.vue'),
    },
    {
      path: 'commissionManage',
      name: 'commissionManage',
      meta: {
        title: '佣金管理',
        keepAlive: true
      },
      component: () =>
        import('@/pages/platformManage/commissionManage/commissionManage.vue'),
    },
    {
      path: 'commissionManageDetail',
      name: 'commissionManageDetail',
      meta: {
        title: '平台佣金',
      },
      component: () =>
        import('@/pages/platformManage/commissionManage/commissionManageDetail.vue'),
    },
    {
      path: 'cashApply',
      name: 'cashApply',
      meta: {
        title: '平台提现审核',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/platformManage/cashApply.vue'),
    },
    {
      path: 'bond',
      name: 'bond',
      meta: {
        title: '保证金管理',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/platformManage/bond/index.vue'),
    },
    {
      path: 'bondDetail',
      name: 'bondDetail',
      meta: {
        title: '保证金查看',
      },
      component: () =>
        import('@/pages/platformManage/bond/detail.vue'),
    },
    {
      path: 'freezeMoney',
      name: 'freezeMoney',
      meta: {
        title: '冻结金额',
      },
      component: () =>
        import('@/pages/platformManage/bond/freezeMoney.vue'),
    },
    {
      path: 'shopApply',
      name: 'shopApply',
      meta: {
        title: '店铺申请',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/platformManage/shopApply/index.vue'),
    },
    {
      path: 'shopApplyEdit',
      name: 'shopApplyEdit',
      meta: {
        title: '申请详情',
      },
      component: () =>
        import('@/pages/platformManage/shopApply/detail.vue'),
    },
    {
      path: 'shopApplyDetail',
      name: 'shopApplyDetail',
      meta: {
        title: '申请详情',
      },
      component: () =>
        import('@/pages/platformManage/shopApply/look.vue'),
    },
    {
      path: 'customerServices',
      name: 'customerServices',
      meta: {
        title: '客服管理',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/platformManage/customerServices.vue'),
    },
    {
      path: 'merchantAccount',
      name: 'merchantAccount',
      meta: {
        title: '平台商户号管理',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/platformManage/merchantAccount/merchantAccount.vue'),
    },
    //  会员中心系统
    {
      path: 'dashboard',
      name: 'dashboard',
      meta: {
        title: '首页',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/merbershipSystems/dashboard/index.vue'),
    },
    {
      path: 'memberInfo',
      name: 'memberInfo',
      meta: {
        title: '会员客户信息',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/merbershipSystems/memberInfo/memberInfo.vue'
        ),
    },
    {
      path: 'userlist',
      name: 'userlist',
      meta: {
        title: '应用管理列表',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/merbershipSystems/userlist/userlist.vue'
        ),
    },
    {
      path: 'integralProportion',
      name: 'integralProportion',
      meta: {
        title: '积分比例设定',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/merbershipSystems/integralProportion/integralProportion.vue'
        ),
    },
    {
      path: 'authorityManagement',
      name: 'authorityManagement',
      meta: {
        title: '权限管理页面',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/merbershipSystems/authorityManagement/authorityManagement.vue'
        ),
    },
    {
      path: 'fieldSetting',
      name: 'fieldSetting',
      meta: {
        title: '客户信息字段设定',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/merbershipSystems/fieldSetting/fieldSetting.vue'
        ),
    },
    //  会员中心系统
    //  公众号
    {
      path: 'officialList',
      name: 'officialList',
      meta: {
        title: '公众号列表',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/official/officialList/officialList.vue'
        ),
    },
    {
      path: 'merchantlist',
      name: 'merchantlist',
      meta: {
        title: '商户列表',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/official/merchantlist/merchantlist.vue'
        ),
    },
    {
      path: 'expressage',
      name: 'expressage',
      meta: {
        title: '字典管理',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/groupManagement/expressage.vue'),
    },
    {
      path: 'parkManage',
      name: 'parkManage',
      meta: {
        title: '停车场管理',
        keepAlive: true,
      },
      component: () =>
        import('@/pages/parkManage/parkManage.vue'),
    },
    {
      path: 'parkManageDetails',
      name: 'parkManageDetails',
      meta: {
        title: '停车场详情',
        keepAlive: false,
      },
      component: () =>
        import('@/pages/parkManage/parkManageDetails.vue'),
    },
    {
      path: 'orderStatistics',
      name: 'orderStatistics',
      meta: {
        title: '订单统计数据',
        keepAlive: true,
      },
      component: () =>
        import(
          '@/pages/orderBox/orderStatistics/orderStatistics'
        ),
    },
    {
      path: 'orderStatisticsDetail',
      name: 'orderStatisticsDetail',
      meta: {
        title: '订单详情',
        keepAlive: false,
      },
      component: () =>
        import(
          '@/pages/orderBox/orderStatistics/orderStatisticsDetail'
        ),
    },
    {
      path: 'dataBoard/index',
      name: 'dataBoardIndex',
      meta: {
        title: '数据报表',
        keepAlive: true,
      },
      component: () => import('@/pages/dataBoard/index.vue'),
    },
    {
      path: 'dataBoard/order',
      name: 'dataBoardOrder',
      meta: {
        title: '订单数据看板',
        keepAlive: true,
      },
      component: () => import('@/pages/dataBoard/order.vue'),
    },
    {
      path: 'dataBoard/customer',
      name: 'dataBoardCustomer',
      meta: {
        title: '客户数据看板',
        keepAlive: true,
      },
      component: () => import('@/pages/dataBoard/customer.vue'),
    },
    {
      path: 'dataBoard/goods',
      name: 'dataBoardGoods',
      meta: {
        title: '商品数据看板',
        keepAlive: true,
      },
      component: () => import('@/pages/dataBoard/goods.vue'),
    },
    {
      path: 'dataBoard/logistics',
      name: 'dataBoardLogistics',
      meta: {
        title: '物流数据看板',
        keepAlive: true,
      },
      component: () => import('@/pages/dataBoard/logistics.vue'),
    },
    {
      path: 'dataBoard/retailers',
      name: 'dataBoardRetailers',
      meta: {
        title: '电商数据看板',
        keepAlive: true,
      },
      component: () => import('@/pages/dataBoard/retailers.vue'),
    },
    {
      path: 'dataBoard/staffDataBak',
      name: 'dataBoardStaffDataBak',
      meta: {
        title: '员工数据看板',
        keepAlive: true,
      },
      component: () => import('@/pages/dataBoard/staffDataBak.vue'),
    },
    {
      path: 'dataBoard/user',
      name: 'user',
      meta: {
        title: '用户运营看板',
        keepAlive: true,
      },
      component: () => import('@/pages/dataBoard/user.vue'),
    },
    {
      path: 'ShortMessage/ShortMessage',
      name: 'ShortMessage',
      meta: {
        title: '短信模板',
        keepAlive: true,
      },
      component: () => import('@/pages/ShortMessage/ShortMessage.vue'),
    },
    {
      path: 'basic/shortLink/pageList',
      name: 'shortLinkPage',
      meta: {
        title: '短链管理',
        keepAlive: true,
      },
      component: () => import('@/pages/basic/shortLink/pageList.vue'),
    },
    {
      path: 'ShortMessage/ShortMessageDetails',
      name: 'ShortMessageDetails',
      meta: {
        title: '短信发送记录',
        keepAlive: true,
      },
      component: () => import('@/pages/ShortMessage/ShortMessageDetails.vue'),
    },
    {
      path: 'LabelGroup/labelManage',
      name: 'LabelManage',
      meta: {
        title: '标签管理',
        keepAlive: false,
      },
      component: () => import('@/pages/LabelGroup/labelManage.vue'),
    },
    {
      path: 'merchantNo',
      name: 'merchantNo',
      meta: {
        title: '商户号管理',
        keepAlive: false,
      },
      component: () => import('@/pages/merchantNo/merchantNo.vue'),
    },
    {
      path: 'LabelGroup/labelAdd',
      name: 'labelAdd',
      meta: {
        title: '添加、编辑标签',
        keepAlive: false,
      },
      component: () => import('@/pages/LabelGroup/labelAdd.vue'),
    },
    {
      path: 'LabelGroup/labelChangeRecord',
      name: 'labelChangeRecord',
      meta: {
        title: '标签变更记录',
        keepAlive: false,
      },
      component: () => import('@/pages/LabelGroup/labelChangeRecord.vue'),
    },
    {
      path: 'LabelGroup/lableRecycleBin',
      name: 'lableRecycleBin',
      meta: {
        title: '标签回收站',
        keepAlive: false,
      },
      component: () => import('@/pages/LabelGroup/lableRecycleBin.vue'),
    },
    {
      path: 'LabelGroup/clientsBands',
      name: 'clientsBands',
      meta: {
        title: '客户分群',
        keepAlive: false,
      },
      component: () => import('@/pages/LabelGroup/clientsBands.vue'),
    },
    {
      path: 'LabelGroup/GroupDetail',
      name: 'LabelGroupDetail',
      meta: {
        title: '客户分群详情',
        keepAlive: false,
      },
      component: () => import('@/pages/LabelGroup/GroupDetail.vue'),

      //  公众号
    },
    {
      path: 'matrix/serverAdmin',
      name: 'serverAdmin',
      meta: {
        title: '服务商管理',
        keepAlive: true,
      },
      component: () => import('@/pages/matrix/serverAdmin.vue'),
    },
    {
      path: 'matrix/serverAdminDetail',
      name: 'serverAdminDetail',
      meta: {
        title: '服务商详情',
        keepAlive: false,
      },
      component: () => import('@/pages/matrix/serverAdminDetail.vue'),
    },
    {
      path: 'matrix/identityAdmin',
      name: 'matrixIdentityAdmin',
      meta: {
        title: '身份设置',
        keepAlive: false,
      },
      component: () => import('@/pages/matrix/identityAdmin.vue'),
    },
    {
      path: 'matrix/GiftManage',
      name: 'matrixGiftManage',
      meta: {
        title: '礼包管理',
        keepAlive: true,
      },
      component: () => import('@/pages/matrix/GiftManage.vue'),
    },
    {
      path: 'matrix/labelManage',
      name: 'matrixlabelManage',
      meta: {
        title: '标签库',
        keepAlive: true,
      },
      component: () => import('@/pages/matrix/labelManage.vue'),
    },
    {
      path: 'matrix/cuponManage',
      name: 'matrixCuponManage',
      meta: {
        title: '优惠券管理',
        keepAlive: false,
      },
      component: () => import('@/pages/matrix/cuponManage.vue'),
    },
    {
      path: 'matrix/pageManage',
      name: 'matrixPageManage',
      meta: {
        title: '页面管理',
        keepAlive: false,
      },
      component: () => import('@/pages/matrix/pageManage.vue'),
    },
    {
      path: 'matrix/setSkip',
      name: 'matrixSetSkip',
      meta: {
        title: '跳转设置',
        keepAlive: true,
      },
      component: () => import('@/pages/matrix/setSkip.vue'),
    },
    {
      path: 'matrix/commission',
      name: 'matrixCommission',
      meta: {
        title: '佣金',
        keepAlive: true,
      },
      component: () => import('@/pages/matrix/commission.vue'),

    },
    {
      path: 'matrix/commissionDetail',
      name: 'matrixCommissionDetail',
      meta: {
        title: '佣金明细',
        keepAlive: false,
      },
      component: () => import('@/pages/matrix/commissionDetail.vue'),
    },
    {
      path: 'matrix/commissionDetails',
      name: 'matrixCommissionDetails',
      meta: {
        title: '佣金详情',
        keepAlive: false,
      },
      component: () => import('@/pages/matrix/commissionDetails.vue'),
    },
    {
      path: 'matrix/integral',
      name: 'matrixIntegral',
      meta: {
        title: '积分',
        keepAlive: true,
      },
      component: () => import('@/pages/matrix/integral.vue'),
    },
    {
      path: 'matrix/integralDetails',
      name: 'matrixIntegralDetails',
      meta: {
        title: '积分详情',
        keepAlive: false,
      },
      component: () => import('@/pages/matrix/integralDetails.vue'),
    },
    {
      path: 'matrix/withdrawMoney',
      name: 'matrixWithdrawMoney',
      meta: {
        title: '提现管理',
        keepAlive: true,
      },
      component: () => import('@/pages/matrix/withdrawMoney.vue'),
    },
    {
      path: 'share/manage',
      name: 'shareManage',
      meta: {
        title: '分享管理',
        keepAlive: true,
      },
      component: () => import('@/pages/share/manage.vue'),
    },
    {
      path: 'share/details',
      name: 'shareDetails',
      meta: {
        title: '分享配置',
        keepAlive: false,
      },
      component: () => import('@/pages/share/details.vue'),
    },
    {
      path: 'pushMessage/manage',
      name: 'pushMessage',
      meta: {
        title: '推送信息管理',
        keepAlive: true,
      },
      component: () => import('@/pages/pushMessage/manage.vue'),
    },
    {
      path: 'matrix/newCupon',
      name: 'matrixNewCupon',
      meta: {
        title: '新增优惠券',
        keepAlive: false,
      },
      component: () => import('@/pages/matrix/newCupon.vue'),
    },
    {
      path: 'domain/list',
      name: 'domainList',
      meta: {
        title: '域名证书',
        keepAlive: true,
      },
      component: () => import('@/pages/basic/domain/list.vue'),
    },
    {
      path: 'domain/infoList',
      name: 'domainInfoList',
      meta: {
        title: '域名过期',
        keepAlive: true,
      },
      component: () => import('@/pages/basic/domain/infoList.vue'),
    },
    {
      path: 'matrix/newPage',
      name: 'matrixNewPage',
      meta: {
        title: '新增页面',
        keepAlive: false,
      },
      component: () => import('@/pages/matrix/newPage.vue'),
    },
    {
      path: 'purchase/supplierList',
      name: 'supplierList',
      meta: {
        title: '供应商管理',
        keepAlive: false,
      },
      component: () => import('@/pages/purchase/supplier/list.vue'),
    },
    {
      path: 'purchase/purchaseFormList',
      name: 'purchaseFormList',
      meta: {
        title: '采购订单管理',
        keepAlive: false,
      },
      component: () => import('@/pages/purchase/purchaseForm/list.vue'),
    },
    {
      path: 'purchase/purchaseReturnList',
      name: 'purchaseReturnList',
      meta: {
        title: '采购退货管理',
        keepAlive: false,
      },
      component: () => import('@/pages/purchase/purchaseReturn/list.vue'),
    },
  ],
}

// 作为Main组件的子页面展示并且在左侧菜单显示的路由写在appRouter里
export const appRouter = [
  {
    path: "",
    name: "toname",
    meta: {
      requireAuth: true,
    },
    component: Layout,
    children: [
      {
        path: "/main_view",
        name: "main_view",
        title: "首页",
        component: () => import("@/pages/main_view/main_view"),
      },
    ],
  },
];

export const routers = [loginRouter, centerRouter, agreementRouter, errorRouter, staiffLoginRouter, otherRouter, ...appRouter];
